import styled from 'styled-components';

export const DialogIconWrapperDefaultBox = styled.div`
    text-align: center;
    color: ${({theme}) => theme.colors.brandPrimary };
    margin: 2em auto;
`;
